import { Navigate, Route, Routes } from 'react-router-dom';

import CustomerDashboard from './Dashboard/CustomerDashboard';
import BookingList from './Bookinglist/Bookinglist';
import Wallet from './wallet/wallet';
import Reviews from './Reviews/Reviews';
import FavoriteServices from './FavoriteServices/FavoriteServices';
import AccountSettings from './AccountSettings/AccountSettings';
import SecuritySettings from './SecuritySettings/SecuritySettings';
import Chat from './Chat/Chat';
import Notifications from './Notification/Notifications';
import SupportTicketPage from './SupportTickets/SupportTicketPage';
import Customerfavorite from './customer- favorite/customerfavorite';
import ConnectedApps from './ConnectedApps/ConnectedApps';
import MyJobRequests from '../Quote/MyJobRequests';
import JobDetail from '../Quote/JobDetail';
import MyPackages from '../Package/MyPackages';

const CustomersRoutes = () => {
  const all_customers_routes = [
    {
      path: '/customer-chat',
      name: 'customer-chat',
      element: <Chat />,
      route: Route,
    },
    {
      path: '/customer-notifications',
      name: 'customer-notifications',
      element: <Notifications />,
      route: Route,
    },
    {
      path: '/customer/',
      name: 'customer-dashboard',
      element: <Navigate to="/customer-dashboard" replace />,
      route: Route,
    },

    {
      path: '/customer-dashboard',
      name: 'customer-dashboard',
      element: <CustomerDashboard />,
      route: Route,
    },

    {
      path: '/customer-booking',
      name: 'customer-booking',
      element: <BookingList />,
      route: Route,
    },

    {
      path: '/customer-wallet',
      name: 'customer-wallet',
      element: <Wallet />,
      route: Route,
    },

    {
      path: '/customer-favourite',
      name: 'customer-favourite',
      element: <Customerfavorite />,
      route: Route,
    },

    {
      path: '/customer-reviews',
      name: 'customer-reviews',
      element: <Reviews />,
      route: Route,
    },
    {
      path: '/customer-favorite-services',
      name: 'customer-favorite-services',
      element: <FavoriteServices />,
      route: Route,
    },
    {
      path: '/customer-support-tickets',
      name: 'customer-support-tickets',
      element: <SupportTicketPage />,
      route: Route,
    },
    {
      path: '/customer-profile',
      name: 'customer-profile',
      element: <AccountSettings />,
      route: Route,
    },

    {
      path: '/customer-security',
      name: 'customer-security',
      element: <SecuritySettings />,
      route: Route,
    },

    {
      path: '/settings/connected-apps',
      name: 'connected-apps',
      element: <ConnectedApps />,
      route: Route,
    },

    // Phase 2 — Quote-based booking (Job vertical)
    {
      path: '/customer-job-requests',
      name: 'customer-job-requests',
      element: <MyJobRequests />,
      route: Route,
    },
    {
      path: '/customer-job/:jobId',
      name: 'customer-job',
      element: <JobDetail />,
      route: Route,
    },

    // Phase 3 — Package-based booking (CustomerPackage vertical)
    {
      path: '/customer-packages',
      name: 'customer-packages',
      element: <MyPackages />,
      route: Route,
    },
  ];
  return (
    <>
      <Routes>
        <Route
          path="/"
          element={<Navigate to="/customer/customer-dashboard" replace />}
        />

        {/* Map all customer routes */}
        {all_customers_routes.map((route, idx) => (
          <Route path={route.path} element={route.element} key={idx} />
        ))}
      </Routes>
    </>
  );
};

export default CustomersRoutes;
